import { SyntheticEvent } from "react";
import { topicList, useWebinarStore } from "../hooks/useWebinars";

const TopicsFilter = () => {
  const topics = useWebinarStore((state) => state.topics);
  const addTopicToFilter = useWebinarStore((state) => state.addTopicToFilter);
  const removeTopicFromFilter = useWebinarStore(
    (state) => state.removeTopicFromFilter
  );

  const handleTopicChange = (
    e: SyntheticEvent<HTMLInputElement>,
    topic: string
  ) => {
    const checked = (e.target as any).checked;

    if (checked) {
      addTopicToFilter(topic);
    } else {
      removeTopicFromFilter(topic);
    }
  };
  return (
    <div className="tw-flex tw-flex-col">
      <h3 className="tw-text-lg tw-mb-2 tw-font-medium">Topics</h3>
      <ul className="tw-pl-4 tw-flex tw-flex-col tw-gap-y-1">
        {topicList.map((topic, idx) => (
          <li key={idx} className="tw-flex tw-items-center tw-gap-x-2">
            <div className="tw-flex tw-items-center tw-h-5">
              <input
                id={topic}
                type="checkbox"
                className="focus:tw-ring-indigo-500 tw-h-4 tw-w-4 tw-text-indigo-600 tw-border-gray-300 tw-rounded"
                checked={topics.has(topic)}
                onChange={(e) => handleTopicChange(e, topic)}
              />
            </div>
            <label
              htmlFor={topic}
              className="tw-select-none tw-cursor-pointer"
              dangerouslySetInnerHTML={{ __html: topic }}
            ></label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopicsFilter;
